import { SelectStatusOptionProps } from "../select-status";

export const shipmentOptions = (
  tEnums: (val: string) => string,
): SelectStatusOptionProps[] => [
    {
      label: tEnums('logistic_shipment_status_pending'),
      value: 'pending',
      variant: 'warning',
    },
    {
      label: tEnums('logistic_shipment_status_delivery_scheduled'),
      value: 'delivery_scheduled',
      variant: 'primary',
    },
    {
      label: tEnums('logistic_shipment_status_in_transit'),
      value: 'in_transit',
      variant: 'primary',
    },
    {
      label: tEnums('logistic_shipment_status_partially_delivered'),
      value: 'partially_delivered',
      variant: 'warning',
    },
    {
      label: tEnums('logistic_shipment_status_delivered'),
      value: 'delivered',
      variant: 'success',
    },
    {
      label: tEnums('logistic_shipment_status_cancelled'),
      value: 'cancelled',
      variant: 'danger',
    },
    {
      label: tEnums('logistic_shipment_status_refused'),
      value: 'refused',
      variant: 'danger',
    },
    {
      label: tEnums('logistic_shipment_status_on_hold'),
      value: 'on_hold',
      variant: 'warning',
    },
  ]